export const PRODUCT_MANY_REQUEST = "PRODUCT_MANY_REQUEST";
export const PRODUCT_MANY_REQUEST_SUCCESS = "PRODUCT_MANY_REQUEST_SUCCESS";
export const PRODUCT_MANY_REQUEST_ERROR = "PRODUCT_MANY_REQUEST_ERROR";

export const PRODUCT_CATEGORY_COUNT_REQUEST = "PRODUCT_CATEGORY_COUNT_REQUEST";
export const PRODUCT_CATEGORY_COUNT_SUCCESS = "PRODUCT_CATEGORY_COUNT_SUCCESS";
export const PRODUCT_CATEGORY_COUNT_ERROR = "PRODUCT_CATEGORY_COUNT_ERROR";

export const PRODUCT_LATEST_REQUEST = "PRODUCT_LATEST_REQUEST";
export const PRODUCT_LATEST_REQUEST_SUCCESS = "PRODUCT_LATEST_REQUEST_SUCCESS";
export const PRODUCT_LATEST_REQUEST_ERROR = "PRODUCT_LATEST_REQUEST_ERROR";

export const PRODUCT_TOP_REQUEST = "PRODUCT_TOP_REQUEST";
export const PRODUCT_TOP_REQUEST_SUCCESS = "PRODUCT_TOP_REQUEST_SUCCESS";
export const PRODUCT_TOP_REQUEST_ERROR = "PRODUCT_TOP_REQUEST_ERROR";

export const PRODUCT_SINGLE_REQUEST = "PRODUCT_SINGLE_REQUEST";
export const PRODUCT_SINGLE_REQUEST_SUCCESS = "PRODUCT_SINGLE_REQUEST_SUCCESS";
export const PRODUCT_SINGLE_REQUEST_ERROR = "PRODUCT_SINGLE_REQUEST_ERROR";

export const PRODUCT_ADD_REQUEST = "PRODUCT_ADD_REQUEST";
export const PRODUCT_ADD_SUCCESS = "PRODUCT_ADD_SUCCESS";
export const PRODUCT_ADD2_SUCCESS = "PRODUCT_ADD2_SUCCESS";

export const PRODUCT_ADD_ERROR = "PRODUCT_ADD_ERROR";

export const PRODUCT_UPDATE_REQUEST = "PRODUCT_UPDATE_REQUEST";
export const PRODUCT_UPDATE_REQUEST_SUCCESS = "PRODUCT_UPDATE_REQUEST_SUCCESS";
export const PRODUCT_UPDATE_SUCCESS = "PRODUCT_UPDATE_SUCCESS";
export const PRODUCT_UPDATE_ERROR = "PRODUCT_UPDATE_ERROR";
export const PRODUCT_UPDATE_RESET = "PRODUCT_UPDATE_RESET";

export const PRODUCT_LIKE_REQUEST = "PRODUCT_LIKE_REQUEST";
export const PRODUCT_LIKE_SUCCESS = "PRODUCT_LIKE_SUCCESS";
export const PRODUCT_LIKE_ERROR = "PRODUCT_LIKE_ERROR";

export const PRODUCT_SHARE_REQUEST = "PRODUCT_SHARE_REQUEST";
export const PRODUCT_SHARE_SUCCESS = "PRODUCT_SHARE_SUCCESS";
export const PRODUCT_SHARE_ERROR = "PRODUCT_SHARE_ERROR";

export const PRODUCT_DELETE_REQUEST = "PRODUCT_DELETE_REQUEST";
export const PRODUCT_DELETE_SUCCESS = "PRODUCT_DELETE_SUCCESS";
export const PRODUCT_DELETE_ERROR = "PRODUCT_DELETE_ERROR";

export const PRODUCT_REVIEW_REQUEST = "PRODUCT_REVIEW_REQUEST";
export const PRODUCT_REVIEW_SUCCESS = "PRODUCT_REVIEW_SUCCESS";
export const PRODUCT_REVIEW_ERROR = "PRODUCT_REVIEW_ERROR";
export const PRODUCT_REVIEW_RESET = "PRODUCT_REVIEW_RESET";
